import { createAsyncThunk } from '@reduxjs/toolkit';
import store from '../../../..';
import ApiaApi, {
  IApiaApiRequestConfig,
  makeApiaUrl,
} from '../../../../../api/apiaApi/apiaApi';
import { TApiaModalRefreshDataResponse } from '../../../../../components/apia/execution/fields/apiaFinder/types';
import { arrayOrArray } from '../../../../../utils/util';
import { buttonsActions } from '../../../../buttonsSlice';
import { TAsyncThunkState, TListRowsStructure } from '../../../types';
import { parseRows } from '../../util/rowsParser';

export type TRefreshData = {
  listId: string;
  url?: string;
  requestConfig?: IApiaApiRequestConfig<unknown>;
  pageNumber?: number;
  queryData?: Record<string, unknown>;
  forceTabId?: boolean;
};

type TRefreshDataResponse = TApiaModalRefreshDataResponse;

const refresh = createAsyncThunk<
  TListRowsStructure,
  TRefreshData,
  TAsyncThunkState
>(
  'listSlice/refresh',
  async (
    { forceTabId = false, listId, requestConfig, url, pageNumber, queryData },
    thunkApi,
  ) => {
    store.dispatch(
      buttonsActions.updateAction([
        {
          performing: true,
          action: 'disableTable',
        },
      ]),
    );
    const state = thunkApi.getState().listSlice.lists[listId];

    const response = await ApiaApi.post<TRefreshDataResponse>(
      url ??
        makeApiaUrl({
          action: 'refresh',
          pageNumber,
          ajaxUrl: state.ajaxUrl,
          tabId: forceTabId ? state.tabId : undefined,
          react: true,
        }),
      { ...requestConfig, ...(queryData ? { queryData } : null) },
    );

    const pageInfo = response?.data?.function?.messages?.result?.pageInfo;
    const row = response?.data?.function?.messages?.result?.table?.row;

    const areSysExce = !!response?.data?.sysMessages;

    store.dispatch(
      buttonsActions.updateAction([
        {
          performing: false,
          action: 'disableTable',
        },
      ]),
    );

    return {
      pageInfo: pageInfo ?? undefined,
      rows: parseRows(listId, (row && arrayOrArray(row)) || []),
      areSysExce,
    };
  },
);

export default refresh;
